(function () {
  function positionCardIcons(card) {
    if (!card) return;

    const priceRow = card.querySelector('.m_square_price_container');
    if (!priceRow) return;

    const heart = card.querySelector('.swym-advanced-wishlist-collections-container');
    const compare = card.querySelector('sc-add-to-compare');
    const share = card.querySelector('.share-widget');

    const icons = [heart, compare, share].filter(Boolean);
    if (!icons.length) return;

    let row = priceRow.querySelector('.card-icon-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'card-icon-row';
    }

    if (row !== priceRow.lastElementChild) {
      priceRow.appendChild(row);
    }

    const heartButton = heart && heart.querySelector('.swym-advanced-wishlist-collections');
    if (heartButton) heartButton.style.setProperty('transform', 'none', 'important');

    // Inline-Reste nur einmal entfernen
    icons.forEach(function (icon) {
      if (icon.dataset.iconCleaned) return;
      ['position', 'top', 'left', 'right', 'bottom', 'margin', 'transform', 'z-index']
        .forEach(function (prop) { icon.style.removeProperty(prop); });
      icon.dataset.iconCleaned = '1';
    });

    // nur umhängen, wenn die Reihenfolge nicht stimmt
    const current = [...row.children];
    const same = current.length === icons.length
      && icons.every(function (icon, i) { return current[i] === icon; });

    if (!same) {
      icons.forEach(function (icon) { row.appendChild(icon); });
    }
  }

  function positionAllCards() {
    document
      .querySelectorAll('.custom-card-wrapper:not(.custom-card-container)')
      .forEach(positionCardIcons);
  }

  window.__positionProductCardIcons = positionAllCards;

  positionAllCards();
  window.addEventListener('load', positionAllCards);

  let rafPending = false;
  const observer = new MutationObserver(function () {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      positionAllCards();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (window.customElements && !customElements.get('sc-add-to-compare')) {
    customElements.whenDefined('sc-add-to-compare').then(function () {
      requestAnimationFrame(positionAllCards);
    });
  }
})();